export const SET_LOADING_REQUEST = 'SET_LOADING_REQUEST'

export const setLoadingRequest = bool => async dispatch => {
  dispatch({
    type: SET_LOADING_REQUEST,
    payload: bool,
  })
}
